import React from 'react';
import HeadingDescription from '../HeadingDescription';
import PointersWithHeading from '../PointersWithHeading';
import ProposalImage from '../ProposalImage';
import TechnicalDataTable from '../TechnicalDataTable';

export default function CycloneSection({ cycloneContent, cycloneImage, cycloneTables = [], isUploadedImage = false }) {
  const hasCyclone = cycloneContent || cycloneTables.length > 0;
  if (!hasCyclone) return null;

  return (
    <>
      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          <div className="quotation-section-block">
            <HeadingDescription heading="Cyclone" description="" level={2} />
            <HeadingDescription
              heading={cycloneContent?.title || 'Cyclone'}
              description={cycloneContent?.description || ''}
              level={3}
            />
            {cycloneContent?.items?.items && (
              <PointersWithHeading
                items={cycloneContent.items.items.map((it) => ({ title: it.title, description: it.description }))}
                numbered
              />
            )}
            {cycloneImage && (
              <ProposalImage
                src={cycloneImage}
                wrapperStyle={{ marginBottom: 12, marginTop: 12, width: '50%', maxWidth: '50%', marginLeft: 'auto', marginRight: 'auto' }}
                imgStyle={isUploadedImage ? { maxHeight: 500, width: 'auto', objectFit: 'contain' } : { width: '100%', maxWidth: '100%' }}
              />
            )}
          </div>
        </div>
      </div>
      {cycloneTables.length > 0 && (
        <div className="a4-paddings quotation-page quotation-page-compact">
          <div className="quotation-page-inner quotation-bg-light">
            {cycloneTables.map((table) => (
              <TechnicalDataTable
                key={table.id}
                data={table.data}
                headers={table.headers}
                title={table.label}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
